const subheader = [{"key":"subheader.contribute_button","string":"Mitwirken"},{"key":"subheader.home","string":"Start"},{"key":"subheader.start","string":"Wissensplattform"},{"key":"subheader.contribute","string":"Mitwirken"},{"key":"subheader.confirm_account","string":"Benutzerkonto bestätigen"},{"key":"subheader.reset_password","string":"Passwort zurücksetzen"},{"key":"subheader.knowledge_repository","string":"Wissensplattform"},{"key":"subheader.yellow_pages","string":"Gelbe Seiten"}]

export default subheader



// WEBPACK FOOTER //
// ./src/i18n/de/subheader/_subheader.js